import { __assign, __extends, __values } from "tslib";
import { Serializable, getStacktrace, toHashMapString, isError } from "@appsignal/core";
var Span = (function (_super) {
    __extends(Span, _super);
    function Span(span) {
        return _super.call(this, __assign({ timestamp: Math.round(new Date().getTime() / 1000), namespace: "frontend", error: {
                name: "NullError",
                message: "No error has been set",
                backtrace: []
            } }, span)) || this;
    }
    Span.prototype.setAction = function (name) {
        if (!name || typeof name !== "string") {
            return this;
        }
        this._data.action = name;
        return this;
    };
    Span.prototype.setNamespace = function (name) {
        if (!name || typeof name !== "string") {
            return this;
        }
        this._data.namespace = name;
        return this;
    };
    Span.prototype.setError = function (error) {
        if (!error || !isError(error))
            return this;
        this._data.error = {
            name: error.name || "[unknown]",
            message: error.message,
            backtrace: getStacktrace(error)
        };
        return this;
    };
    Span.prototype.setTags = function (tags) {
        this._data.tags = __assign(__assign({}, this._data.tags), toHashMapString(tags));
        return this;
    };
    Span.prototype.setParams = function (params) {
        this._data.params = __assign(__assign({}, this._data.params), params);
        return this;
    };
    Span.prototype.setBreadcrumbs = function (breadcrumbs) {
        this._data.breadcrumbs = breadcrumbs;
        return this;
    };
    Span.prototype.setEnvironment = function (environment) {
        this._data.environment = __assign(__assign({}, this._data.environment), environment);
        return this;
    };
    Span.prototype.cleanBacktracePath = function (matchBacktracePaths) {
        if (matchBacktracePaths.length === 0) {
            return this;
        }
        if (!this._data.error || !this._data.error.backtrace) {
            return this;
        }
        var linesMatched = 0;
        this._data.error.backtrace = this._data.error.backtrace.map(function (line) {
            var e_1, _a;
            var path = extractPath(line);
            if (!path) {
                return line;
            }
            try {
                for (var _b = __values(matchBacktracePaths), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var matcher = _c.value;
                    var match = path.match(matcher);
                    if (!match || match.length < 2) {
                        continue;
                    }
                    var relevantPath = match.slice(1).join("");
                    if (relevantPath) {
                        linesMatched++;
                        return line.replace(path, relevantPath);
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return line;
        });
        if (linesMatched > 0) {
            this.setEnvironment({
                backtrace_paths_matched: linesMatched.toString()
            });
        }
        return this;
    };
    return Span;
}(Serializable));
export { Span };
function extractPath(backtraceLine) {
    var IS_CHROME = /^\s*at\s/;
    var CHROME_PATH = /at(?:\s.*)?\s\(?(.*):\d*:\d*\)?$/i;
    if (backtraceLine.match(IS_CHROME)) {
        var match = backtraceLine.match(CHROME_PATH);
        return match ? match[1] : undefined;
    }
    var IS_SAFARI_FF = /^.*@/;
    var SAFARI_FF_PATH = /@\s?(.*):\d*:\d*$/i;
    if (backtraceLine.match(IS_SAFARI_FF)) {
        var match = backtraceLine.match(SAFARI_FF_PATH);
        return match ? match[1] : undefined;
    }
}
//# sourceMappingURL=span.js.map